var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocketsLockR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    transform: "rotate(90 16 16)",
    fill: "#171F36",
    stroke: "#58FE90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2001 7C12.4386 7 10.2001 9.23858 10.2001 12V12.9623C8.895 13.621 8 14.9737 8 16.5354V19.1181C8 21.3272 9.79086 23.1181 12 23.1181H20C22.2091 23.1181 24 21.3272 24 19.1181V16.5354C24 14.9737 23.1051 13.6211 21.8001 12.9624V12C21.8001 9.23858 19.5615 7 16.8001 7H15.2001ZM19.8001 12.5354V12C19.8001 10.3431 18.4569 9 16.8001 9H15.2001C13.5432 9 12.2001 10.3431 12.2001 12V12.5354H19.8001Z",
    fill: "#C2C4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 21H13.6V13.99H16.65C17.2567 13.99 17.74 14.1467 18.1 14.46C18.4667 14.7667 18.65 15.1367 18.65 15.57V17.06C18.65 17.34 18.5633 17.6033 18.39 17.85C18.2233 18.09 17.9867 18.28 17.68 18.42L18.81 21H17.27L16.22 18.62H15.08V21ZM16.47 15.31H15.08V17.31H16.49C16.69 17.31 16.8533 17.26 16.98 17.16C17.1133 17.06 17.18 16.9167 17.18 16.73V15.89C17.18 15.6967 17.1133 15.5533 16.98 15.46C16.8467 15.36 16.6767 15.31 16.47 15.31Z",
    fill: "#304477"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocketsLockR);
export default __webpack_public_path__ + "static/media/sockets-lock-r.6b7580eb4a22cbb33628dac8eca95bdb.svg";
export { ForwardRef as ReactComponent };